export default __webpack_public_path__ + "play-store-button.a472f4c59b6b7bd6bcb01ce649916693.png";